import { makeStyles } from "@material-ui/core";
import { useEffect, useReducer } from "react";
import CustomTabStyle from "../../componentes/tabs/CustomTabStyle";
import CustomTabs from "../../componentes/tabs/CustomTabs";
import { useTranslation } from "react-i18next";
import a11yProps from "../../componentes/tabs/a11Props";
import TabPanel from "../../componentes/tabs/TabPanel";
import FormContainer from "../../componentes/form-container/FormContainer";
import SearchIcon from "@material-ui/icons/Search";

import ProductColoplast from "./ProductColoplast";
import ProductUfi from "./ProductUfi";
import ProductMotul from "./ProductMotul";
import ProductGeneric from "./ProductGeneric";

/**
 * Author : AndréK
 * 26/08/2022
 */

const useStyles = makeStyles(() => ({
    root: {
        marginRight: 10,
    },
}));

const reducer = (state, data) => ({ ...state, ...data });

const ProductControl = () => {

    const loggedIdClient = Number(sessionStorage.getItem("idClient") || 0);
    const { t } = useTranslation();
    const classes = useStyles();

    const [state, dispatch] = useReducer(reducer, {
        id: 0,
        tabValue: 0
    });

    const { tabValue } = state;

    const handleTabChange = (event, newValue) =>
        dispatch({ tabValue: newValue });

    /* ===== Abas dinâmicas ===== */
    const tabs = [];

    if (loggedIdClient === 0 || loggedIdClient === 1) {
        tabs.push({
            key: "coloplast",
            label: t("productColoplast"),
            component: <ProductColoplast updateId={dispatch} />
        });
    }

    if (loggedIdClient === 0 || loggedIdClient === 2) {
        tabs.push({
            key: "ufi",
            label: t("productUfi"),
            component: <ProductUfi updateId={dispatch} />
        });
    }

    if (loggedIdClient === 0 || loggedIdClient === 8) {
        tabs.push({
            key: "motul",
            label: t("productMotul"),
            component: <ProductMotul updateId={dispatch} />
        });
    }

    if (loggedIdClient === 0 || (loggedIdClient !== 1 && loggedIdClient !== 2 && loggedIdClient !== 8)) {
        tabs.push({
            key: "generic",
            label: t("productGeneric"),
            component: <ProductGeneric updateId={dispatch} />
        });
    }

    /* ===== Aba inicial ===== */
    useEffect(() => {
        let index = 0;

        // if (loggedIdClient === 1) {
        //     index = tabs.findIndex(t => t.key === "coloplast");
        // }
        // else if (loggedIdClient === 2) {
        //     index = tabs.findIndex(t => t.key === "ufi");
        // }
        // else if (loggedIdClient === 8) {
        //     index = tabs.findIndex(t => t.key === "motul");
        // }

        if (loggedIdClient === 1) {
            index = tabs.findIndex(t => t.key === "coloplast");
        }
        else if (loggedIdClient === 2) {
            index = tabs.findIndex(t => t.key === "ufi");
        }
        else if (loggedIdClient === 8) {
            index = tabs.findIndex(t => t.key === "motul");
        }

        if (index < 0) index = 0;

        dispatch({ tabValue: index });
    }, [loggedIdClient]);

    return (
        <FormContainer>
            <CustomTabs
                value={tabValue}
                onChange={handleTabChange}
                variant="scrollable"
                scrollButtons="auto"
                aria-label="product tab"
            >
                {tabs.map((tab, index) => (
                    <CustomTabStyle
                        key={tab.key}
                        label={tab.label}
                        {...a11yProps(index)}
                        icon={<SearchIcon fontSize="small" classes={classes} />}
                    />
                ))}
            </CustomTabs>

            {tabs.map((tab, index) => (
                <TabPanel key={tab.key} value={tabValue} index={index}>
                    {tab.component}
                </TabPanel>
            ))}
        </FormContainer>
    );
};

export default ProductControl;
